import PropTypes from "prop-types";
import { Container } from "@circle-react/components/shared/Container";
import { useHomepageContext } from "./HomepageContext";

export const HomepageContentWrapper = ({ children }) => {
  const { hasSidebarContent } = useHomepageContext();
  const maxWidth = hasSidebarContent ? "lg" : "md";
  return <Container maxWidth={maxWidth}>{children}</Container>;
};

HomepageContentWrapper.propTypes = {
  children: PropTypes.node,
};
